import React, { useState } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import useUpdate from 'hooks/useUpdate';

import WarehouseViewMode from 'components/admin/warehouse/WarehouseDetail/WarehouseViewMode';
import WarehouseEditForm from 'components/admin/warehouse/WarehouseDetail/WarehouseEditForm';

import { adminWarehouseApi } from 'api';

import { isValidValue, parseFormValue } from 'utils/valueFormatters';

const WarehouseSection = ({ warehouseId, warehouse, refetch }) => {
  const [isEditing, setIsEditing] = useState(false);

  const {
    update,
    loading: updateLoading,
    error: updateError,
  } = useUpdate(adminWarehouseApi, 'patchForm');

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSubmit = async (e, imageStates) => {
    e.preventDefault();

    try {
      const formData = new FormData(e.target);

      const fieldTypes = {
        name: 'string',
        party_name: 'string',
        inventory_available: 'boolean',
        address_name: 'string',
        address_line_1: 'string',
        address_line_2: 'string',
        address_city: 'string',
        address_state: 'string',
        address_country: 'string',
        address_pincode: 'string',
        address_email: 'string',
        address_phone: 'string',
        gstin: 'string',
      };

      Object.entries(fieldTypes).forEach(([field, type]) => {
        const value = formData.get(field);
        if (isValidValue(value)) {
          formData.set(field, parseFormValue(value, type));
        }
      });

      ['logo_image', 'signature_image'].forEach(imageField => {
        const imageState = imageStates[imageField];
        if (imageState.hasChanged) {
          if (imageState.isRemoved) {
            formData.set(imageField, '');
          } else if (imageState.file) {
            formData.set(imageField, imageState.file);
          }
        }
      });

      await update(warehouseId, formData);
      await refetch();

      setIsEditing(false);
      toast.success('Warehouse updated successfully');
    } catch (err) {
      toast.error('Failed to update warehouse');
    }
  };

  return (
    <Card>
      <Card.Header className="bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <h5 className="mb-0">Warehouse Detail</h5>

            <small className="text-muted ms-2">
              Address for AWB, Shipping Invoice
            </small>
          </div>

          {!isEditing && (
            <Button variant="primary" size="sm" onClick={handleEditClick}>
              <FontAwesomeIcon icon="edit" className="me-2" />
              Edit
            </Button>
          )}
        </div>
      </Card.Header>

      <Card.Body>
        {updateError && <Alert variant="danger">{updateError}</Alert>}

        {isEditing ? (
          <WarehouseEditForm
            warehouse={warehouse}
            onSubmit={handleSubmit}
            onCancel={() => setIsEditing(false)}
            isLoading={updateLoading}
          />
        ) : (
          <WarehouseViewMode warehouse={warehouse} />
        )}
      </Card.Body>
    </Card>
  );
};

export default WarehouseSection;
